import {
  ElementType,
  ValidationType,
  FormElementMap,
  FormElement,
  ElementStatus,
} from "@/@types/entities/forms";

const HeaderBody: FormElementMap[ElementType.Header] = {
  type: ElementType.Header,
  name: "",
  label: "Escribir un encabezado....",
  status: ElementStatus.Active,
};

const FileBody: FormElementMap[ElementType.File] = {
  type: ElementType.File,
  name: "",
  label: "Cargar archivo",
  instruction: "",
  required: false,
  status: ElementStatus.Active,
};

const ShortTextBody: FormElementMap[ElementType.ShortText] = {
  type: ElementType.ShortText,
  name: "",
  label: "Texto corto",
  instruction: "",
  validation: ValidationType.TextAndNumber,
  required: false,
  status: ElementStatus.Active,
};

const LongTextBody: FormElementMap[ElementType.LongText] = {
  type: ElementType.LongText,
  name: "",
  label: "Texto Largo",
  instruction: "",
  validation: ValidationType.TextAndNumber,
  required: false,
  status: ElementStatus.Active,
};

const SingleOptionBody: FormElementMap[ElementType.SingleOption] = {
  type: ElementType.SingleOption,
  name: "",
  label: "Escribe una pregunta",
  instruction: "",
  options: [
    { id: 1, value: "Opción 1" },
    { id: 2, value: "Opción 2" },
    { id: 3, value: "Opción 3" },
  ],
  has_other_option: false,
  required: false,
  status: ElementStatus.Active,
};

const MultipleOptionsBody: FormElementMap[ElementType.MultipleOptions] = {
  type: ElementType.MultipleOptions,
  name: "",
  label: "Escribe una pregunta",
  instruction: "",
  options: [
    { id: 1, value: "Opción 1" },
    { id: 2, value: "Opción 2" },
    { id: 3, value: "Opción 3" },
  ],
  has_other_option: false,
  selection_limit: null,
  required: false,
  status: ElementStatus.Active,
};

const DropdownBody: FormElementMap[ElementType.Dropdown] = {
  type: ElementType.Dropdown,
  name: "",
  label: "Desplegable",
  instruction: "",
  options: [
    { id: 1, value: "Opción 1" },
    { id: 2, value: "Opción 2" },
    { id: 3, value: "Opción 3" },
  ],
  required: false,
  status: ElementStatus.Active,
};

const ReminderBody: FormElementMap[ElementType.Reminder] = {
  type: ElementType.Reminder,
  name: "",
  label: "Crear recordatorio",
  instruction: "",
  element_inputs: { title: "", date: "", hour: "", description: "" },
  required: false,
  status: ElementStatus.Active,
};

const DateBody: FormElementMap[ElementType.Date] = {
  type: ElementType.Date,
  name: "",
  label: "Fecha",
  instruction: "",
  is_range: false,
  required: false,
  status: ElementStatus.Active,
};

const HourBody: FormElementMap[ElementType.Hour] = {
  type: ElementType.Hour,
  name: "",
  label: "Hora",
  instruction: "",
  is_range: false,
  required: false,
  status: ElementStatus.Active,
};

const PdpBody: FormElementMap[ElementType.Pdp] = {
  type: ElementType.Pdp,
  name: "",
  label: "Promesa de Pago (PDP)",
  instruction: "",
  element_inputs: { date: "", currency: "", amount: "" },
  required: true,
  status: ElementStatus.Active,
};

export const BodyByType: Record<ElementType, FormElement> = {
  header: HeaderBody,
  file: FileBody,
  "short-text": ShortTextBody,
  "long-text": LongTextBody,
  "single-option": SingleOptionBody,
  "multiple-options": MultipleOptionsBody,
  dropdown: DropdownBody,
  reminder: ReminderBody,
  date: DateBody,
  hour: HourBody,
  pdp: PdpBody,
};
